module.exports = __webpack_public_path__ + "img/service_feedback.a912fa7b.svg";